import moment from 'moment';
import React, { useEffect } from 'react';
import { Calendar, momentLocalizer, Views } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { fetchCalendarEvents } from '../../store/actions/eventsActions';
import { convertHexToRgba } from '../../utils/commonFunctions';
import CalendarEvent from '../CalendarEvent';
import './index.scss';

const localizer = momentLocalizer(moment);

const CALENDAR_HEIGHT = 600;
const DEFAULT_STEP = 50;
const STEP_CALIBRATION_FACTOR = 440; // step is inversely proportional to maxEvents

const EventsCalendar = ({ fetchCalendarEvents, events }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    fetchCalendarEvents();
  }, [fetchCalendarEvents]);

  moment.locale(i18n.language);
  // ensure Monday is the first day of the week
  moment.updateLocale(i18n.language, { week: { dow: 1 } });

  // calculate max events per day to set the step size for the calendar
  const maxEventsPerDay = events.reduce((acc, event) => {
    const date = moment(event.start).format('YYYY-MM-DD');
    acc[date] = (acc[date] || 0) + 1;
    return acc;
  }, {});
  const maxEvents = Math.max(...Object.values(maxEventsPerDay), 0);
  const step =
    maxEvents > 0
      ? Math.round(STEP_CALIBRATION_FACTOR / maxEvents)
      : DEFAULT_STEP;

  return events && events.length ? (
    <div className="calendar-container">
      <Calendar
        localizer={localizer}
        views={[Views.WEEK]}
        defaultView={Views.WEEK}
        events={events}
        style={{ height: CALENDAR_HEIGHT }}
        toolbar={false}
        timeslots={1}
        step={step}
        culture="de-DE"
        selectable={false}
        formats={{
          dayFormat: (date, _, localizer) => localizer.format(date, 'dddd'),
        }}
        components={{
          week: {
            event: CalendarEvent,
          },
        }}
        eventPropGetter={(event) => ({
          style: {
            backgroundColor: convertHexToRgba(event.resource.color, 0.2),
            order: event.resource.order,
          },
        })}
      />
    </div>
  ) : null;
};

const mapStateToProps = (state) => {
  return {
    events: state.events.events,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCalendarEvents: () => dispatch(fetchCalendarEvents()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventsCalendar);
